import React from 'react';
import SectionTabs from '../../components/SectionTabs';
import Campaigns from './campaigns/Campaigns';
import ManagementNotifications from './Notifications';
import ManagementEmailTemplates from './EmailTemplates';
import CampaignAgent from './campaigns/CampaignAgent';

/**
 * Communication : tout ce que Dingo envoie aux utilisateurs, en un seul
 * endroit.
 *  - « Campagnes » (par défaut) : proposées par l'API ou écrites à la main,
 *    relues et validées avant envoi — c'est là que quelque chose attend.
 *  - « Push » (`?vue=push`) : notifications libres et leur historique.
 *  - « E-mails » (`?vue=emails`) : modèles d'e-mail (lecture, réécriture) et
 *    campagnes e-mail tirées d'un modèle.
 *  - « Agent » (`?vue=agent`, expérimental) : conversation avec l'IA pour
 *    trouver des idées et écrire des campagnes push, poussées ensuite en
 *    relecture dans « Campagnes ».
 */
const CommunicationHub = () => (
  <SectionTabs
    ariaLabel="Type d’envoi"
    views={[
      { id: 'campagnes', label: 'Campagnes', render: () => <Campaigns /> },
      { id: 'push', label: 'Push', render: () => <ManagementNotifications /> },
      { id: 'emails', label: 'E-mails', render: () => <ManagementEmailTemplates /> },
      { id: 'agent', label: 'Agent', badge: 'Expérimental', render: () => <CampaignAgent /> }
    ]}
  />
);

export default CommunicationHub;
